module.exports = __webpack_public_path__ + "static/media/video.f44c1d8d.webm";